import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild,ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { PolicyServicingAppSettings } from '../policyServicing-configs'
import { Logger } from '../../../BaseFramework/core/services/logger/logger.service';
import { AuthenticationService } from '../../../BaseFramework/core/authentication';

const log = new Logger();

@Injectable()
export class PolicyServicingAuthenticationGuard implements CanActivate {

  constructor(private router: Router,
              private authenticationService: AuthenticationService,
              private appSettings:PolicyServicingAppSettings
              ) { }

  canActivate(): boolean {
    if (this.authenticationService.isAuthenticated() && this.validatePrivileges()) {
      return true;
    }

    log.debug('Not authorized, redirecting...');
    this.router.navigate(['/login'], { replaceUrl: true });
    return false;
  }

  canActivateChild(): boolean {
    return this.canActivate();
  }

  validatePrivileges(){
    var isValid = this.authenticationService.checkUserPrivilege(this.appSettings._allowedRoles)

    return isValid;
  }

}
